import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProductionWorkOrder, ProductionWorkOrderSearchCommand } from '../../models/production/production-work-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class ProductionWorkOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.productionApi}/api/v1/production-work-order`;

  getById(id: string, materialize = true): Observable<ApiResponse<ProductionWorkOrder>> {
    return this.httpClient.get<ApiResponse<ProductionWorkOrder>>(`${this.baseUrl}/${id}?materialize=${materialize}`);
  }

  search(
    command: ProductionWorkOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<ProductionWorkOrder>>> {
    let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      queryParams += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ProductionWorkOrder>>>(`${this.baseUrl}/search${queryParams}`, command);
  }
}
